import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState("helipad", ["structures", "types"]),
    ...mapGetters("helipad", ["getStructureNameById", "getTypeNameById"])
  },

  methods: {
    fetchHelipadData(methodName) {
      this.$store.cache.dispatch(
        `helipad/${methodName}`,
        { collection: this.$collection, limit: 50 },
        { timeout: 1800000 }
      );
    },

    fetchHelipadStructures() {
      this.fetchHelipadData("fetchStructures");
    },

    fetchHelipadTypes() {
      this.fetchHelipadData("fetchTypes");
    },

    fetchAllHelipadElements() {
      this.fetchHelipadStructures();
      this.fetchHelipadTypes();
    }
  }
};
